import { Metric } from 'web-vitals';

import { swallowStaleChunkError } from '@/lib/chunkRecovery';

type Handler = (metric: Metric) => void;

export const reportWebVitals = (cb?: Handler) => {
  if (typeof window === 'undefined' || typeof cb !== 'function') return;

  // the rejection handler is the second `then` argument, not a trailing `catch`, so it
  // never swallows an error thrown by the callbacks above it
  import('web-vitals').then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
    const opts = { reportAllChanges: true } as const;
    onCLS(cb, opts);
    onINP(cb, opts);
    onLCP(cb, opts);
    onFCP(cb, opts);
    onTTFB(cb, opts);
  }, swallowStaleChunkError);
};
